import script from "./productGroupsAppearance.vue?vue&type=script&setup=true&lang=ts"
export * from "./productGroupsAppearance.vue?vue&type=script&setup=true&lang=ts"

import "./productGroupsAppearance.vue?vue&type=style&index=0&id=7ba77cbb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba77cbb"]])

export default __exports__